import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_LOCALE_ID } from '@shared/util/util';
import { splitFieldPaths, valueOnPath } from '../utils/common.util';
import { CustomFieldModel } from '../modules/rest/custom-field/model/custom-field.model';
import { CustomFieldTypesEnum } from '../modules/rest/custom-field/enums/custom-field-types.enum';
import { FormatDatePipe } from './format-date.pipe';

@Pipe({
  name: 'recordDisplayValue',
})
export class RecordDisplayValuePipe implements PipeTransform {

  formatDatePipe = new FormatDatePipe(DEFAULT_LOCALE_ID);

  transform(item: any, object: { mainField?: string; secondField?: string; fields?: CustomFieldModel[] }): string {
    if (!item) {
      return '';
    }
    if (!object?.mainField && !object?.secondField) {
      console.error('Object mainField and secondField not defined!');
      return '';
    }
    const mainFieldValue = this.getFieldValue(item, object?.mainField, object);
    const secondFieldValue = this.getFieldValue(item, object?.secondField, object);
    return [mainFieldValue, secondFieldValue].filter(Boolean).join(' ');
  }

  private getFieldValue(item: any, fieldPaths: string, object: { fields?: CustomFieldModel[] }): string {
    if (!fieldPaths) {
      return '';
    }

    // Split by spaces to support multiple paths (e.g., "fizickoLice.ime fizickoLice.prezime")
    const pathArray = splitFieldPaths(fieldPaths);

    // Extract and format value for each path
    const values = pathArray
      .map(path => {
        const field = this.findField(object, path);
        const value = valueOnPath(item, path);
        return this.formatValue(field, value);
      })
      .filter(value => value !== null && value !== undefined && value !== '');

    // Join all values with a space
    return values.join(' ');
  }

  private findField(object: { fields?: CustomFieldModel[] }, dbName: string): CustomFieldModel {
    if (object?.fields) {
      return object.fields
        .find(field => field.dbName === dbName);
    }
    return null;
  }

  private formatValue(field: CustomFieldModel, value: any): any {
    if (!field) {
      return value == null ? '' : value;
    }
    if (value == null) {
      return '';
    }
    if (field.type === CustomFieldTypesEnum.DATE) {
      if (!value) {
        return value;
      }
      return this.formatDatePipe.transform(value);
    }
    return value;
  }
}

@NgModule({
  declarations: [RecordDisplayValuePipe],
  exports: [RecordDisplayValuePipe],
})
export class RecordDisplayValuePipeModule {
}
